/**
 * @param {ReviewStatistics} statistics
 */
export default function parseStatisticsData(statistics) {
  return {
    averageRating: statistics.averageOverallRating,
    totalCount: statistics.totalReviewCount,
    countPerRating: statistics.ratingDistribution
      .sort((a, b) => b.ratingValue - a.ratingValue)
      .map((x) => ({
        rating: x.ratingValue,
        count: x.count,
        percentage: (x.count / statistics.totalReviewCount) * 100,
      })),
    sliders: Object.values(statistics.averageSliders).map((obj) => ({
      title: obj.label,
      value: obj.value,
      valueRange: obj.valueRange,
      minLabel: obj.minLabel,
      midLabel: obj.midLabel,
      maxLabel: obj.maxLabel,
    })),
  };
}
